import type { BankAccountFormSchemaType } from '@common';
import {
  useApproveBankAccountMutation,
  useDeleteBankAccountMutation,
  useUpdateBankAccountMutation,
} from './hooks';

export type UseBankAccountMutationsReturnType = {
  submitUpdateBankAccount: (
    data: BankAccountFormSchemaType,
    bankAccountId: string
  ) => Promise<void>;
  submitDeleteBankAccount: (
    bankAccountId: string,
    reason: string
  ) => Promise<void>;
  handleApproveBankAccount: (bankAccountId: string) => void;
  isDeletePending: boolean;
};

export const useBankAccountMutations =
  (): UseBankAccountMutationsReturnType => {
    const { submitUpdateBankAccount } = useUpdateBankAccountMutation();
    const { submitDeleteBankAccount, isDeletePending } =
      useDeleteBankAccountMutation();
    const { handleApproveBankAccount } = useApproveBankAccountMutation();

    return {
      submitUpdateBankAccount,
      submitDeleteBankAccount,
      handleApproveBankAccount,
      isDeletePending,
    };
  };
